import React from "react";
import { Row, Col } from "react-bootstrap";
import Component from "@reactions/component";
import { Checkbox, SelectMenu, Button } from "evergreen-ui";
import Cookies from "universal-cookie";
import Lottie from "lottie-react-web";
import Host from "../../assets/js/Host";
import NewTask from "./NewTask";
// import { Redirect } from "react-router-dom";
import Tasknwe1 from "./Tasknwe1";
import RangePicker from "react-range-picker";
import moment from "moment";
import TaskOthers from "./TaskOthers";
import { toast } from "react-toastify";
import DetialsCustomer from "../CustomersCare/DetialsCustomer";
import { ChromePicker } from "react-color";
import APP_CONSTANTS from "../../assets/js/constants";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { useEffect } from "react";
import Preloading from "../Preload/Preloading";
import { useCallback } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router";
import NoFOundImage from '../../assets/img/no-content.png'
import NewTicketView from "./NewTicketView";
import NewTicketViewCustomer from "../CustomersCare/NewTicketViewCustomer";
import axios from "../../assets/js/AxiosInterceptors";


const cookies = new Cookies();
const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("id");
const DetialsTaskEdit = () => {
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const myRef = React.useRef(null);
  const [tasks, setTasks] = useState([]);
  const [tasks1, setTasks1] = useState([]);
  const [users, setUsers] = useState([]);
  const [newState, setNewState] = useState([]);
  const [assigned, setAssigned] = useState([]);
  const [inprogress, setInprogress] = useState([]);
  const [closed, setClosed] = useState([]);
  const [approved, setApproved] = useState([]);
  const [rejected, setRejected] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [archived, setArchived] = useState([]);
  const [afterfilter, setAfterfilter] = useState("");
  const [search, setSearch] = useState([]);
  const [date, setDate] = useState([]);
  const [date1, setDate1] = useState(
    moment(moment().format("L")).format("X") * 1000
  );
  const [date2, setDate2] = useState(0);
  const [check, setCheck] = useState("");
  const [watt, setWatt] = useState("yes");
  const [all, setAll] = useState([]);
  const [wait, setWait] = useState(true);
  const [range, setRange] = useState([]);
  const [allday, setAllday] = useState("");
  const [spin, setSpin] = useState(false);
  const [commentLength, setCommentLength] = useState([]);
  const [noti, setNoti] = useState([]);
  const [status1, setStatus1] = useState("new");
  const [checked, setChecked] = useState(true);
  const [status2, setStatus2] = useState("in progress");
  const [checked2, setChecked2] = useState(true);
  const [status3, setStatus3] = useState("closed");
  const [checked3, setChecked3] = useState(true);
  const [status4, setStatus4] = useState("approved");
  const [checked4, setChecked4] = useState(true);
  const [status5, setStatus5] = useState("rejected");
  const [checked5, setChecked5] = useState(true);
  const [status6, setStatus6] = useState("archived");
  const [checked6, setChecked6] = useState(true);
  const [selectedAssignFrom, setSelectedAssignFrom] = useState("");
  const [selectedAssignTo, setSelectedAssignTo] = useState("");
  const [selectedTaskType, setSelectedTaskType] = useState("");
  const [type, setType] = useState([]);
  const [geofences, setGeofences] = useState([]);
  const [force, setForce] = useState(0);
  const filterRef = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const navigate=useNavigate()

  const handleClearAllClick = () => {
    filterRef.current.clearAll();
  };
  useEffect(() => {
    if (myParam) handleLoadData();
  }, [myParam]);

  const loadStatusData = async () => {
    setLoading(true);
    try {
      var headers = {
        jwt: cookies.get("token"),
      };
      let data = await axios({
        url: Host + `tasks/statuses`,
        method: "GET",
        headers: headers,
      });
      setLoading(false);
      if (data?.status) {
        let arr = [];
        for (let index = 0; index < data.data.data.length; index++) {
          let obj = {
            label: data.data.data[index].status_name,
            value: data.data.data[index].status_id,
          };
          arr.push(obj);
        }
        setStatuses(arr);
      } else {
      }
    } catch (err) {
      console.log(err?.message);
    }
  };
  const loadUsers = async () => {
    setLoading(true);
    try {
      var headers = {
        jwt: cookies.get("token"),
      };
      let data = await axios({
        url: Host + `users/userslist`,
        method: "GET",
        headers: headers,
        params: {
          enabled: 1,
        }
      });
      setLoading(false);

      if (data?.status) {
        let arr = [];
        for (let index = 0; index < data.data.data.length; index++) {
          let obj = {
            label: data.data.data[index].name,
            value: data.data.data[index].user_id,
          };
          arr.push(obj);
        }
        console.log("users=>1", arr);
        setUsers(arr);
      } else {
      }
    } catch (err) {
      console.log(err?.message);
    }
  };
  const getGeofences = async () => {
    setLoading(true);

    var headers = {
      jwt: cookies.get("token"),
    };
    try {
      let data = await axios({
        url: Host + `tasks/task_geofences?params={"force":${force}}`,
        method: "GET",
        headers: headers,
      });
      setLoading(false);

      if (data?.status) {
        setGeofences(data.data.data.data);
      } else {
      }
    } catch (err) {
      console.log(err?.message);
    }
  };
  const loadTaskType = async () => {
    setLoading(true);

    try {
      var headers = {
        jwt: cookies.get("token"),
      };
      let data = await axios({
        url: Host + `task_types`,
        method: "GET",
        headers: headers,
      });
      setLoading(false);

      if (data?.status) {
        if (data.data.status === false) {
          cookies.remove("token");
          window.location.href = "/";
        } else {
          let arr = [];
          for (let index = 0; index < data.data.data.length; index++) {
            if (
              data.data.data[index].task_type_id == 2 ||
              data.data.data[index].task_type_id == 12 ||
              data.data.data[index].task_type_id == 9
            ) {
              //Removing واجبات التركيب والصيانة + محافظات + كوستمر كير from select task type
              continue;
            } else {
              let obj = {
                label: data.data.data[index].name,
                value: data.data.data[index].task_type_id,
              };
              arr.push(obj);
            }
            setType(arr);
          }
        }
      } else {
      }
    } catch (err) {
      console.log(err?.message);
    }
  };
  const loadTasks = async () => {
    setLoading(true);
    setSkeletonLoading(true)
    try {
      var headers = {
        jwt: cookies.get("token"),
      };
      let data = await axios({
        url: Host + `tasks/task/${myParam}?params={"from_date":0,"to_date":0}`,
        method: "GET",
        headers: headers,
      });
      setLoading(false);
      setSkeletonLoading(false)

      if (data?.status) {
        if (data?.data?.data && data?.data?.data?.length > 0) {
          setNoData(false);
        } else {
          setNoData(true);
        }
        setNoti(data?.data?.data);
        setWait("no");
        setCheck("login");
      } else {
      }
    } catch (err) {
      setSkeletonLoading(false)
      setLoading(false)
      console.log(err?.message);
    }
  };

  // useEffect(()=>{
  //     loadUsers();
  // },[ noti])

  // useEffect(()=>{
  //     loadStatusData();
  // },[ users])

  // useEffect(()=>{
  //     getGeofences();
  // },[ statuses])

  // useEffect(()=>{
  //     loadTaskType()
  // },[ Geofences])

  const handleLoadData = () => {
    loadTasks();
    loadUsers();
    loadStatusData();
    getGeofences();
    loadTaskType();
  };

  useEffect(() => {
    console.log("users=>2", users);
  }, [users]);

  const RefreshGeofences = () => {
    setForce(1);
    setTimeout(() => {
      getGeofences();
    }, 200);
  };

  return (
    <div className="">
      {/* {loading ? <Preloading /> : null} */}
      {!loading && noData ? (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginTop: "100px",
          }}
        >
          <Box
            sx={{
              width: "400px",
              height: "300px",
              backgroundColor: "#f3f3f3",
              borderRadius: "5px",
              marginBottom: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            {/* <ReplayIcon sx={{ fontSize: "80px", color: "#1e6a99" }} /> */}
            <img
              src={NoFOundImage}
              style={{
                width: "200px",
                height: "200px",
              }}
            />
          </Box>
          <span>This Task ID: {myParam} is Not Found</span>
        </Box>
      ) : (
        <>
          <div id="apfot" ref={myRef}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              <Row style={{ width: "100%", display: "flex" }}>
                {noti.length > 0 ? (
                  <Col md={12} >
                    {noti[0].task_title &&
                    noti[0].task_title !== "null" &&
                    ![
                      APP_CONSTANTS.CUSTOMER_CARE_TYPE,
                      APP_CONSTANTS.INSTALLATION_TYPE,
                      APP_CONSTANTS.EXTERNAL_CUSTOMER_CARE_TYPE,
                    ].includes(noti[0].task_type_id) ? (
                      <NewTicketView
                        close_status_name={noti[0].close_status_name}
                        name={noti[0].task_title}
                        num_of_units={noti[0].num_of_units}
                        contacted_person={noti[0].contacted_person}
                        contacted_num={noti[0].contacted_num}
                        time={noti[0].dead_time}
                        desc={noti[0].description}
                        id={noti[0].task_id}
                        users={users}
                        assigners={noti[0].assigners}
                        onRefTask={() => handleLoadData()}
                        status={noti[0].status}
                        allstatus={statuses}
                        createdby={noti[0].issuer_user?.name}
                        created_at={noti[0].created_at}
                        assigned={noti[0].assigners.map((p, i) => p.user_id)}
                        comments_count={noti[0].comments_count}
                        type={type}
                        task_type={noti[0].task_type}
                        monitor={noti[0].monitor}
                        files={noti[0].files}
                        priority={noti[0].priority}
                        geofences={noti[0].geofences}
                        Geofences={geofences}
                        weight={noti[0].weight}
                        onRefreshGeo={() => RefreshGeofences()}
                        externalTasks={
                          noti[0]?.sub_tasks && noti[0]?.sub_tasks?.length > 0
                            ? noti[0]?.sub_tasks[0]?.task_type_id == 15
                              ? 1
                              : 0
                            : noti[0]?.task_type_id == 15
                            ? 1
                            : 0
                        }
                        externalTasks_v2={
                          noti[0]?.task_type_id == 15
                            ? 1
                            :noti[0]?.sub_tasks && noti[0]?.sub_tasks?.length > 0
                            ? noti[0]?.sub_tasks[0]?.task_type_id == 15
                              ? 1
                              : 0
                            :0
                        }
                        SubTaskId={
                          noti[0]?.sub_tasks && noti[0]?.sub_tasks?.length > 0
                            ? noti[0]?.sub_tasks[0]?.task_id
                            : noti[0]?.main_task_id
                        }
                        TaskId={myParam}
                        is_mission_task={noti[0]?.is_mission_task}
                        setSkeletonLoading={setSkeletonLoading}
                        skeletonLoading={skeletonLoading}
                        erp_cus_id={noti[0]?.erp_cus_id}
                        task_type_id={noti[0].task_type_id}
                      />
                    ) : (
                      <NewTicketViewCustomer
                        close_status_name={noti[0].close_status_name}
                        name={noti[0].task_title}
                        time={noti[0].dead_time}
                        desc={noti[0].description}
                        id={noti[0].task_id}
                        users={users}
                        assigners={noti[0].assigners}
                        onRefTask={() => handleLoadData()}
                        contacted_person={noti[0].contacted_person}
                        contacted_num={noti[0].contacted_num}
                        governorate_name={noti[0].governorate_name}
                        governorate_id={noti[0].governorate_id}
                        task_type_id={noti[0].task_type_id}
                        work_type_name={noti[0].work_type_name}
                        num_of_units={noti[0].num_of_units}
                        status={noti[0].status}
                        allstatus={statuses}
                        createdby={noti[0].issuer_user?.name}
                        created_at={noti[0].created_at}
                        assigned={noti[0].assigners.map((p, i) => p.user_id)}
                        comments_count={noti[0].comments_count}
                        type={type}
                        task_type={noti[0].task_type}
                        monitor={noti[0].monitor}
                        files={noti[0].files}
                        priority={noti[0].priority}
                        geofences={noti[0].geofences}
                        Geofences={geofences}
                        weight={noti[0].weight}
                        onRefreshGeo={() => RefreshGeofences()}
                        customer={noti[0].customer}
                        units={noti[0].units}
                        account_name={noti[0]?.contacted_person}
                        user_name={noti[0]?.issuer_user?.name}
                        rate_score={noti[0].rate_score}
                        rate_text={noti[0].rate_text}
                        request_type_name={noti[0]?.request_type?.name}
                        request_location={noti[0]?.request_location}
                        prefered_time={noti[0]?.prefered_time}
                        prefered_date={noti[0]?.prefered_date}
                        request_type={noti[0]?.request_type}
                        externalTasks={
                          noti[0]?.sub_tasks && noti[0]?.sub_tasks?.length > 0
                            ? noti[0]?.sub_tasks[0]?.task_type_id == 15
                              ? 1
                              : 0
                            : noti[0]?.task_type_id == 15
                            ? 1
                            : 0
                        }
                        externalTasks_v2={
                          noti[0]?.task_type_id == 15
                            ? 1
                            :noti[0]?.sub_tasks && noti[0]?.sub_tasks?.length > 0
                            ? noti[0]?.sub_tasks[0]?.task_type_id == 15
                              ? 1
                              : 0
                            :0
                        }
                        SubTaskId={
                          noti[0]?.sub_tasks && noti[0]?.sub_tasks?.length > 0
                            ? noti[0]?.sub_tasks[noti[0]?.sub_tasks?.length - 1]
                                ?.task_id
                            : noti[0]?.main_task_id
                        }
                        TaskId={myParam}
                        is_mission_task={noti[0]?.is_mission_task}
                        setSkeletonLoading={setSkeletonLoading}
                        skeletonLoading={skeletonLoading}
                        loadData={loadTasks}
                        sub_tasks={noti[0]?.sub_tasks}
                        taskData={noti[0]}
                        erp_cus_id={noti[0]?.erp_cus_id}
                        task_details={noti[0].task_details}
                        task_finances={noti[0].task_finances}
                      />
                    )}
                  </Col>
                ) : null}
              </Row>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DetialsTaskEdit;
